import { getUserData } from '../../utils/token'

export default store => ({
  path: 'expiredLogin',
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const expiredLogin = require('./containers').default
        cb(null, expiredLogin)
      },
      'expiredLogin'
    )
  },
  onEnter: ({ location }, replace) => {
    const user = getUserData()

    if (!user) {
      const { pathname, search } = location
      replace(`login`)
    }
  }
})



// WEBPACK FOOTER //
// ./src/routes/ExpiredLogin/index.js